import EmployeeInfo from "../../employeeInfo/employeeInfoCM"

const EmploDeReport=({})=>{
    return <EmployeeInfo gridSize={{
        sm:6,
        xs:12
      }} />
}

export default EmploDeReport